// As abas da navegação principal e onde a navegação aparece. Separado do componente para os testes rodarem sem o
// navegador.
import type { Rota } from './rotas.ts';

export const TELAS_COM_NAVEGACAO = ['inicio', 'ranking', 'amigos', 'perfil'] as const;
export type TelaComNavegacao = (typeof TELAS_COM_NAVEGACAO)[number];
export const temNavegacao = (t: Rota['tela']): t is TelaComNavegacao => (TELAS_COM_NAVEGACAO as readonly string[]).includes(t);

// No computador, o trilho fica em toda tela fora da sala e da mesa. Ficam sem ele: a sala e a plateia, a busca de mesa
// da liga (que leva à mesa), o placar ao vivo do marcador (telão) e as telas de passagem (indicação e Stripe simulada).
const SEM_TRILHO: readonly Rota['tela'][] = ['sala', 'assistir', 'liga', 'placar', 'indicacao', 'simulado', 'compra-simulada'];
export const temTrilho = (t: Rota['tela']) => !SEM_TRILHO.includes(t);

// A aba acesa em cada tela: a tela principal de onde ela sai.
const ABA_DA_TELA: Partial<Record<Rota['tela'], TelaComNavegacao>> = {
  inicio: 'inicio', 'nova-sala': 'inicio', marcador: 'inicio', noites: 'inicio', limite: 'inicio', notificacoes: 'inicio',
  ranking: 'ranking', comunidade: 'ranking', 'nova-comunidade': 'ranking', 'convite-comunidade': 'ranking', campeonato: 'ranking', 'novo-campeonato': 'ranking',
  amigos: 'amigos', jogador: 'amigos',
  perfil: 'perfil', configuracoes: 'perfil', conquistas: 'perfil', missoes: 'perfil', colecao: 'perfil', passe: 'perfil', estatisticas: 'perfil',
  trios: 'perfil', 'novo-trio': 'perfil', trio: 'perfil', 'convite-trio': 'perfil', indique: 'perfil', planos: 'perfil', assinar: 'perfil',
  'assinatura-ok': 'perfil', 'meu-plano': 'perfil', loja: 'perfil', extrato: 'perfil', 'compra-ok': 'perfil', 'como-jogar': 'perfil',
  termos: 'perfil', privacidade: 'perfil',
};
// Quem está no Grátis tem o item ASSINAR no menu (item 59.2): a tela Planos acende ele; para quem assina, acende o Perfil.
export type ItemDoMenu = TelaComNavegacao | 'assinar';
export const abaDaTela = (t: Rota['tela'], gratis = false): ItemDoMenu | null => (gratis && t === 'planos' ? 'assinar' : ABA_DA_TELA[t] ?? null);
